import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "permission-management app-page app-page--fill" }
const _hoisted_2 = { class: "panel-header" }
const _hoisted_3 = { class: "search-box" }
const _hoisted_4 = { class: "tree-wrapper" }
const _hoisted_5 = { class: "tree-node" }
const _hoisted_6 = { class: "node-label" }
const _hoisted_7 = { class: "tree-options" }
const _hoisted_8 = { class: "right-panel" }
const _hoisted_9 = { class: "panel-header" }
const _hoisted_10 = { class: "panel-title" }
const _hoisted_11 = {
  key: 0,
  class: "header-actions"
}
const _hoisted_12 = {
  key: 0,
  class: "user-content"
}
const _hoisted_13 = { class: "filter-bar" }
const _hoisted_14 = { class: "user-name-cell" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 0,
  class: "pagination-wrapper"
}
const _hoisted_18 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_19 = { class: "permission-dialog-content" }
const _hoisted_20 = {
  key: 0,
  class: "role-list-wrapper"
}
const _hoisted_21 = { class: "role-item" }
const _hoisted_22 = { class: "role-item__name" }
const _hoisted_23 = {
  key: 0,
  class: "role-item__desc"
}

import { computed, ref, reactive, watch, onMounted, onUnmounted, nextTick } from 'vue'
import { ElMessage } from 'element-plus'
import { Search, Refresh, Key, OfficeBuilding } from '@element-plus/icons-vue'
import type { ElTree } from 'element-plus'
import { PermissionManagement } from '@/network'
import { useButtonPermission } from '@/utils/buttonPermission'

interface DepartmentNode {
  value: string
  Pid: string
  label: string
  order: number
  disabled: boolean
  children: DepartmentNode[] | null
}

interface RoleInfo {
  Id: string
  Name: string
  Description: string | null
  Enabled: boolean
  OrderSort: number
  IsDeleted: boolean
}

interface UserInfo {
  uID: string
  uLoginName: string
  uRealName: string
  uStatus: number
  DepartmentId: string
  DepartmentName: string
  uRemark: string
  uCreateTime: string
  uUpdateTime: string
  uErrorCount: number
  name: string | null
  sex: number
  age: number
  addr: string | null
  tdIsDelete: boolean
  RoleNames: string[]
  DataPermissions: string
  Dids: string[]
  RIDs: string[]
}

// 树形控件相关
const minPanelWidth = 200

export default /*@__PURE__*/_defineComponent({
  __name: 'fenpei',
  setup(__props) {

const { can } = useButtonPermission('/QuanXianGuanLi/fenpei.vue')

// 类型定义
const treeRef = ref<InstanceType<typeof ElTree>>()
const treeProps = {
  children: 'children',
  label: 'label',
  disabled: 'disabled'
}

// 布局相关
const mainContentRef = ref<HTMLElement | null>(null)
const leftPanelRef = ref<HTMLElement | null>(null)
const tableWrapperRef = ref<HTMLElement | null>(null)
const leftPanelWidth = ref<number>(400)
const isResizing = ref<boolean>(false)
const tableMaxHeight = ref<number>(500)
let tableResizeObserver: ResizeObserver | null = null

// 数据相关
const departmentTree = ref<DepartmentNode[]>([])
const currentDepartment = ref<DepartmentNode | null>(null)
const userList = ref<UserInfo[]>([])
const filterText = ref('')
const userSearchText = ref('')
const showSubUsers = ref(false)

// 加载状态
const treeLoading = ref(false)
const userLoading = ref(false)

// 分页
const pagination = reactive({
  page: 1,
  pageSize: 20,
  total: 0
})

const displayUserList = computed(() => {
  const start = (pagination.page - 1) * pagination.pageSize
  const end = start + pagination.pageSize
  return userList.value.slice(start, end)
})

// 权限弹窗
const permissionDialogVisible = ref(false)
const currentUser = ref<UserInfo | null>(null)
const roleList = ref<RoleInfo[]>([])
const selectedRoleIds = ref<string[]>([])
const roleLoading = ref(false)
const roleSubmitting = ref(false)

// 数据权限
const selectedDataPermission = ref('')

// 部门搜索处理
const handleDepartmentSearch = () => {
  treeRef.value?.filter(filterText.value)
}

// 树节点筛选方法
const filterNode = (value: string, data: DepartmentNode) => {
  if (!value) return true
  return data.label.includes(value)
}

// 拖拽调整宽度
const startResize = () => {
  isResizing.value = true
  document.addEventListener('mousemove', handleResizePanel)
  document.addEventListener('mouseup', stopResize)
  document.body.style.cursor = 'col-resize'
  document.body.style.userSelect = 'none'
}

const handleResizePanel = (e: MouseEvent) => {
  if (!isResizing.value || !mainContentRef.value) return
  const containerRect = mainContentRef.value.getBoundingClientRect()
  const maxWidth = containerRect.width * 0.5
  let newWidth = e.clientX - containerRect.left
  newWidth = Math.max(minPanelWidth, Math.min(maxWidth, newWidth))
  leftPanelWidth.value = newWidth
}

const stopResize = () => {
  isResizing.value = false
  document.removeEventListener('mousemove', handleResizePanel)
  document.removeEventListener('mouseup', stopResize)
  document.body.style.cursor = ''
  document.body.style.userSelect = ''
}

const stopTableResizeObserver = () => {
  tableResizeObserver?.disconnect()
  tableResizeObserver = null
}

const syncTableResizeObserver = () => {
  stopTableResizeObserver()

  if (!tableWrapperRef.value || typeof ResizeObserver === 'undefined') return

  tableResizeObserver = new ResizeObserver(() => {
    calculateTableHeight()
  })
  tableResizeObserver.observe(tableWrapperRef.value)
}

// 计算表格最大高度
const calculateTableHeight = () => {
  nextTick(() => {
    const tableWrapperEl = tableWrapperRef.value
    if (!tableWrapperEl) return

    const computedStyle = window.getComputedStyle(tableWrapperEl)
    const paddingTop = parseFloat(computedStyle.paddingTop) || 0
    const paddingBottom = parseFloat(computedStyle.paddingBottom) || 0
    const availableHeight = tableWrapperEl.clientHeight - paddingTop - paddingBottom - 8

    tableMaxHeight.value = Math.max(Math.floor(availableHeight), 240)
  })
}

// 加载部门树
const loadDepartmentTree = async () => {
  try {
    treeLoading.value = true
    const res: any = await PermissionManagement.getDepartmentTree({ pid: '0' })

    if (res && res.status === 200 && res.success && res.response) {
      if (res.response.children && Array.isArray(res.response.children)) {
        departmentTree.value = res.response.children
      } else {
        departmentTree.value = [res.response]
      }
    } else {
      departmentTree.value = []
      ElMessage.warning('获取部门数据失败')
    }
  } catch (error) {
    console.error('加载部门树失败:', error)
    departmentTree.value = []
    ElMessage.error('加载部门数据失败')
  } finally {
    treeLoading.value = false
  }
}

// 点击树节点
const handleNodeClick = (data: DepartmentNode) => {
  currentDepartment.value = data
  userSearchText.value = ''
  pagination.page = 1
  loadUserList()
}

// 显示下级人员复选框切换
const handleShowSubUsersChange = () => {
  if (currentDepartment.value) {
    pagination.page = 1
    loadUserList()
  }
}

// 人员姓名搜索
const handleUserSearch = () => {
  pagination.page = 1
  loadUserList()
}

// 加载用户列表
const loadUserList = async () => {
  if (!currentDepartment.value) return
  
  try {
    userLoading.value = true
    const res: any = await PermissionManagement.getDepartmentUser({
      nameKey: userSearchText.value || undefined,
      departmentId: currentDepartment.value.value,
      includesSubordinates: showSubUsers.value,
    })

    if (res && res.status === 200 && res.success && res.response) {
      userList.value = Array.isArray(res.response.data) ? res.response.data : []
      pagination.total = userList.value.length

      const maxPage = Math.max(1, Math.ceil(pagination.total / pagination.pageSize))
      if (pagination.page > maxPage) {
        pagination.page = maxPage
      }
    } else {
      userList.value = []
      pagination.total = 0
      ElMessage.warning('获取人员数据失败')
    }
  } catch (error) {
    console.error('加载用户列表失败:', error)
    userList.value = []
    pagination.total = 0
    ElMessage.error('加载人员数据失败')
  } finally {
    userLoading.value = false
  }
}

// 分页处理
const handleSizeChange = (size: number) => {
  pagination.pageSize = size
  pagination.page = 1
  calculateTableHeight()
}

const handlePageChange = (page: number) => {
  pagination.page = page
  calculateTableHeight()
}

const getTableIndex = (index: number) => {
  return (pagination.page - 1) * pagination.pageSize + index + 1
}

// 加载角色列表
const loadRoleList = async () => {
  try {
    roleLoading.value = true
    const res: any = await PermissionManagement.getAllRole()

    if (res && res.status === 200 && res.success && res.response) {
      roleList.value = Array.isArray(res.response.data) ? res.response.data : []
    } else {
      roleList.value = []
      ElMessage.warning('获取角色列表失败')
    }
  } catch (error) {
    console.error('加载角色列表失败:', error)
    roleList.value = []
    ElMessage.error('加载角色列表失败')
  } finally {
    roleLoading.value = false
  }
}

// 权限配置
const handlePermission = (user: UserInfo) => {
  currentUser.value = { ...user }
  selectedRoleIds.value = user.RIDs ? [...user.RIDs] : []
  selectedDataPermission.value = user.DataPermissions || ''
  permissionDialogVisible.value = true
  loadRoleList()
}

// 确认角色分配
const handleConfirmRole = async () => {
  if (!currentUser.value) return
  try {
    roleSubmitting.value = true

    // 1. 保存角色权限
    const payload = {
      ...currentUser.value,
      RIDs: selectedRoleIds.value
    }
    const res: any = await PermissionManagement.updateUseRole(payload)

    if (res && res.status === 200 && res.success) {
      ElMessage.success('角色分配成功')
    } else {
      ElMessage.warning(res?.msg || '角色分配失败')
      return
    }

    // 2. 保存数据权限
    if (selectedDataPermission.value && currentUser.value.uID) {
      try {
        const dataPermRes: any = await PermissionManagement.SetUserDataPermissions({
          userId: currentUser.value.uID,
          Permissions: selectedDataPermission.value
        })
        if (dataPermRes && dataPermRes.status === 200 && dataPermRes.success) {
          ElMessage.success('数据权限设置成功')
        }
      } catch (dataErr) {
        console.error('数据权限保存失败:', dataErr)
        ElMessage.warning('数据权限保存失败，请重试')
      }
    }

    permissionDialogVisible.value = false
    loadUserList()
  } catch (error) {
    console.error('角色分配失败:', error)
    ElMessage.error('角色分配失败')
  } finally {
    roleSubmitting.value = false
  }
}

// 组件挂载
watch(tableWrapperRef, () => {
  syncTableResizeObserver()
  calculateTableHeight()
})

onMounted(() => {
  loadDepartmentTree()
  calculateTableHeight()
  window.addEventListener('resize', calculateTableHeight)
  
  nextTick(() => {
    if (mainContentRef.value) {
      const containerWidth = mainContentRef.value.getBoundingClientRect().width
      leftPanelWidth.value = Math.min(400, containerWidth * 0.3)
    }

    syncTableResizeObserver()
  })
})

onUnmounted(() => {
  document.removeEventListener('mousemove', handleResizePanel)
  document.removeEventListener('mouseup', stopResize)
  window.removeEventListener('resize', calculateTableHeight)
  stopTableResizeObserver()
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { class: "main-card" }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "main-content",
          ref_key: "mainContentRef",
          ref: mainContentRef
        }, [
          _createElementVNode("div", {
            class: "left-panel",
            ref_key: "leftPanelRef",
            ref: leftPanelRef,
            style: _normalizeStyle({ width: leftPanelWidth.value + 'px' })
          }, [
            _createElementVNode("div", _hoisted_2, [
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "panel-title" }, "部门结构", -1)),
              _createVNode(_component_el_button, {
                type: "primary",
                icon: _unref(Refresh),
                circle: "",
                size: "small",
                class: "app-refresh-btn",
                onClick: loadDepartmentTree,
                loading: treeLoading.value,
                title: "刷新"
              }, null, 8, ["icon", "loading"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_input, {
                modelValue: filterText.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterText).value = $event)),
                placeholder: "搜索部门",
                "prefix-icon": _unref(Search),
                clearable: "",
                size: "default",
                onKeyup: _withKeys(handleDepartmentSearch, ["enter"]),
                onClear: handleDepartmentSearch
              }, null, 8, ["modelValue", "prefix-icon"]),
              _createVNode(_component_el_button, {
                type: "primary",
                size: "default",
                onClick: handleDepartmentSearch
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createTextVNode("搜索")
                ])),
                _: 1
              })
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_el_tree, {
                ref_key: "treeRef",
                ref: treeRef,
                data: departmentTree.value,
                props: treeProps,
                "node-key": "value",
                "filter-node-method": filterNode,
                "expand-on-click-node": false,
                "highlight-current": "",
                onNodeClick: handleNodeClick
              }, {
                default: _withCtx(({ node }) => [
                  _createElementVNode("span", _hoisted_5, [
                    _createVNode(_component_el_icon, { class: "node-icon" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OfficeBuilding))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(node.label), 1)
                  ])
                ]),
                _: 1
              }, 8, ["data"]),
              (!treeLoading.value && departmentTree.value.length === 0)
                ? (_openBlock(), _createBlock(_component_el_empty, {
                    key: 0,
                    description: "暂无部门数据"
                  }))
                : _createCommentVNode("", true)
            ])), [
              [_directive_loading, treeLoading.value]
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_checkbox, {
                modelValue: showSubUsers.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showSubUsers).value = $event)),
                onChange: handleShowSubUsersChange
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode("显示下级人员")
                ])),
                _: 1
              }, 8, ["modelValue"])
            ])
          ], 4),
          _createElementVNode("div", {
            class: "resize-handle",
            onMousedown: startResize
          }, null, 32),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, [
                _createTextVNode(_toDisplayString(currentDepartment.value ? currentDepartment.value.label : '请选择部门') + " ", 1),
                (currentDepartment.value)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 0,
                      type: "info",
                      size: "small",
                      style: {"margin-left":"8px"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(pagination.total) + " 人 ", 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              (currentDepartment.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      icon: _unref(Refresh),
                      circle: "",
                      size: "small",
                      class: "app-refresh-btn",
                      onClick: loadUserList,
                      title: "刷新"
                    }, null, 8, ["icon"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (currentDepartment.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_el_input, {
                      modelValue: userSearchText.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((userSearchText).value = $event)),
                      placeholder: "搜索人员姓名",
                      "prefix-icon": _unref(Search),
                      clearable: "",
                      style: {"width":"240px"},
                      onClear: handleUserSearch,
                      onKeyup: _withKeys(handleUserSearch, ["enter"])
                    }, null, 8, ["modelValue", "prefix-icon"]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "default",
                      onClick: handleUserSearch
                    }, {
                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                        _createTextVNode("搜索")
                      ])),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", {
                    class: "table-wrapper",
                    ref_key: "tableWrapperRef",
                    ref: tableWrapperRef
                  }, [
                    _createVNode(_component_el_table, {
                      data: displayUserList.value,
                      stripe: "",
                      border: "",
                      style: {"width":"100%"},
                      "max-height": tableMaxHeight.value
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          type: "index",
                          label: "序号",
                          width: "60",
                          align: "center",
                          index: getTableIndex
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "uRealName",
                          label: "姓名",
                          "min-width": "100"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(_component_el_avatar, { size: 32 }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString((row.uRealName || '').charAt(0)), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("span", null, _toDisplayString(row.uRealName || '-'), 1)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "uLoginName",
                          label: "账号",
                          "min-width": "130"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "DepartmentName",
                          label: "部门",
                          "min-width": "130"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "uRemark",
                          label: "创建人",
                          "min-width": "120",
                          "show-overflow-tooltip": ""
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "RoleNames",
                          label: "角色",
                          "min-width": "140"
                        }, {
                          default: _withCtx(({ row }) => [
                            (row.RoleNames && row.RoleNames.length > 0)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(row.RoleNames, (role, idx) => {
                                  return (_openBlock(), _createBlock(_component_el_tag, {
                                    key: idx,
                                    type: "primary",
                                    size: "small",
                                    style: {"margin":"2px"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(role), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              : (_openBlock(), _createElementBlock("span", _hoisted_15, "-"))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "DataPermissions",
                          label: "数据权限",
                          "min-width": "120"
                        }, {
                          default: _withCtx(({ row }) => [
                            (row.DataPermissions)
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 0,
                                  type: "warning",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(row.DataPermissions), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : (_openBlock(), _createElementBlock("span", _hoisted_16, "-"))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "uUpdateTime",
                          label: "更新时间",
                          "min-width": "140",
                          "show-overflow-tooltip": ""
                        }),
                        (_unref(can)('保存分配'))
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 0,
                              label: "操作",
                              width: "100",
                              align: "center",
                              fixed: "right"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  icon: _unref(Key),
                                  size: "small",
                                  onClick: ($event: any) => (handlePermission(row))
                                }, {
                                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                                    _createTextVNode(" 权限 ")
                                  ])),
                                  _: 2
                                }, 1032, ["icon", "onClick"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["data", "max-height"])
                  ], 512),
                  (pagination.total > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createVNode(_component_el_pagination, {
                          "current-page": pagination.page,
                          "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((pagination.page) = $event)),
                          "page-size": pagination.pageSize,
                          "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((pagination.pageSize) = $event)),
                          "page-sizes": [10, 20, 50, 100],
                          total: pagination.total,
                          layout: "total, sizes, prev, pager, next, jumper",
                          small: "",
                          onSizeChange: handleSizeChange,
                          onCurrentChange: handlePageChange
                        }, null, 8, ["current-page", "page-size", "total"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(_component_el_empty, { description: "请在左侧选择一个部门查看人员信息" })
                ]))
          ])), [
            [_directive_loading, userLoading.value]
          ])
        ], 512)
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: permissionDialogVisible.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((permissionDialogVisible).value = $event)),
      title: `角色列表 - ${currentUser.value?.uRealName || ''}`,
      width: "600px",
      "close-on-click-modal": false,
      teleported: true,
      "lock-scroll": true,
      class: "permission-role-dialog"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (permissionDialogVisible.value = false))
        }, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        (_unref(can)('保存分配'))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              loading: roleSubmitting.value,
              onClick: handleConfirmRole
            }, {
              default: _withCtx(() => _cache[15] || (_cache[15] = [
                _createTextVNode("角色分配")
              ])),
              _: 1
            }, 8, ["loading"]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createVNode(_component_el_descriptions, {
            column: 1,
            border: "",
            style: {"margin-bottom":"16px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_descriptions_item, { label: "姓名" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(currentUser.value?.uRealName || '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "账号" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(currentUser.value?.uLoginName || '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "部门" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(currentUser.value?.DepartmentName || currentDepartment.value?.label || '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "数据权限" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: selectedDataPermission.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedDataPermission).value = $event)),
                    placeholder: "请选择数据权限",
                    style: {"width":"200px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "个人数据",
                        value: "个人数据"
                      }),
                      _createVNode(_component_el_option, {
                        label: "部门数据",
                        value: "部门数据"
                      }),
                      _createVNode(_component_el_option, {
                        label: "全部数据",
                        value: "全部数据"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (!roleLoading.value && roleList.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createVNode(_component_el_empty, { description: "暂无角色数据" })
              ]))
            : (_openBlock(), _createBlock(_component_el_scrollbar, {
                key: 1,
                class: "role-list-scroll"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_checkbox_group, {
                    modelValue: selectedRoleIds.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedRoleIds).value = $event)),
                    class: "role-list"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleList.value, (role) => {
                        return (_openBlock(), _createBlock(_component_el_checkbox, {
                          key: role.Id,
                          label: role.Id,
                          disabled: !role.Enabled || role.IsDeleted,
                          class: "role-checkbox"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, _toDisplayString(role.Name), 1),
                              (role.Description)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(role.Description), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["label", "disabled"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }))
        ])), [
          [_directive_loading, roleLoading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})